export default "__VITE_ASSET__BqDIamXI__"